import React, { useContext, useEffect } from 'react';
import Configurator from '../components/configurator/Configurator';
import BuyWardrobeBodyConfigs from '../components/configurationOptions/BuyWardrobeBodyConfig';
import ProgressBar from '../components/ProgressBar';
import { connect } from 'react-redux';
import { ConfiguratorModeContext } from '../contexts/ConfiguratorModeContext';
import ReactGA from 'react-ga';
import { ownProgressive } from '../helpers/buyAccessories';

const BuyWardrobeBody = props => {
  ReactGA.event(
    {
      category: 'Buy wardrobe',
      action: 'Buy wardrobe',
      transport: 'beacon',
    },
    ['tracker1', 'tracker2'],
  );
  const { dimensions } = props;
  const { setCurrentConfiguratorMode } = useContext(ConfiguratorModeContext);

  const slidePoints = [];
  let activeSliding = false;
  let activeHinged = false;
  let doorBreakpoint = null;

  if (dimensions) {
    if (dimensions.width.hasOwnProperty(1)) {
      activeHinged = true;
      dimensions.width[1].map(item => {
        if (typeof item === 'number') {
          slidePoints.push(item);
        }
        return null;
      });
    }

    if (dimensions.width.hasOwnProperty(2)) {
      activeSliding = true;
      slidePoints.push(...dimensions.width[2]);
      doorBreakpoint = dimensions.width[2][0];
    }
  }

  useEffect(() => {
    setCurrentConfiguratorMode(1);
    /* eslint-disable-next-line */
  }, []);

  return (
    <Configurator slidePoints={slidePoints} doorBreakpoint={doorBreakpoint}>
      <ProgressBar activeLvl={1} ownProgressive={ownProgressive} />
      <BuyWardrobeBodyConfigs
        dimensions={dimensions}
        activeHinged={activeHinged}
        activeSliding={activeSliding}
      />
    </Configurator>
  );
};

export default connect(null, null)(BuyWardrobeBody);
